import { forEach } from 'lodash';
import { Action, InputType } from '@projectstorm/react-canvas-core';
import { DefaultLinkModel } from '@projectstorm/react-diagrams';
import { toast } from 'react-toastify';
import BandwidthLinkModel from '../CustomLink/BandwidthLink/BandwidthLinkModel';
import WarningInfoIcon from '../../../../assets/images/warn-toast-icon.svg';
import CrossConnectLinkModel from '../CustomLink/CrossConnectLink/CrossConnectLinkModel';

interface CustomDeleteItemsActionOptions {
  keyNames?: string[];
}
/**
 * Deletes all selected items, but asks for confirmation first
 */
export default class CustomDeleteItemsAction extends Action {
  constructor(options: CustomDeleteItemsActionOptions = {}) {
    options = {
      keyNames: ['Backspace', 'Delete'],
      ...options,
    };
    super({
      type: InputType.KEY_DOWN,
      fire: (event: any) => {
        if (options.keyNames?.indexOf(event.event.code) !== -1) {
          const selectedEntities = this.engine.getModel().getSelectedEntities();
          let openPorts = JSON.parse(localStorage.getItem('expandedGroupIds') || '[]'); 
          if (selectedEntities.length == 1) {
            forEach(selectedEntities, (entity: any) => {
              if (!entity.isLocked() && entity instanceof DefaultLinkModel && !(entity instanceof BandwidthLinkModel)) { // its a link but not bandwidth
                if (entity.getOptions().extras && !entity.getOptions().extras.sourceCollapsed && !entity.getOptions().extras.targetCollapsed) { // it is cross connect and endpoints are expanded
                  entity.remove();
                } else if (openPorts.includes(entity.getSourcePort().getOptions().extras.data.groupId) && openPorts.includes(entity.getTargetPort().getOptions().extras.data.groupId)) {
                  entity.remove(); 
                } else if (!(entity instanceof CrossConnectLinkModel)) { // its dirty data
                  entity.remove();
                } else {
                  toast.warn('You must expand the groups to delete a cross connect', { autoClose: 750, icon: <img src={WarningInfoIcon} alt="Error" className="error-icon" /> });
                }
              }
            });
          }
        }
      },
    });
  }
}
